export default {
  created() {
    this.$api = {}
    this.$api.get = (url, ops) => {
      ops = ops || {}

      return this.$axios.get(url, {
        ...ops,
        headers: {
          authorization: `Bearer ${this.getAuthorization()}`,
        },
        baseURL: ops.baseURL || this.commonJs.localUrl,
      })
    }

    this.$api.post = (url, data, ops) => {
      ops = ops || {}

      return this.$axios.post(url, data, {
        ...ops,
        headers: {
          authorization: `Bearer ${this.getAuthorization()}`,
        },
        baseURL: ops.baseURL || this.commonJs.localUrl,
      })
    }
  },
}
